import { Table } from '@tanstack/react-table';
import React from 'react';
import { LuRotateCcw } from 'react-icons/lu';

import { Button } from '../ui/button';

interface ResetFiltersProps<T> {
    table: Table<T>;
    onReset?: () => void;
}

export function ResetFilters<T>({ table, onReset }: ResetFiltersProps<T>) {
    const handleReset = () => {
        if (onReset) {
            onReset();
        } else {
            table.resetColumnFilters();
            table.resetSorting();
        }
    };

    return (
        <Button variant="outline" size="sm" className="gap-2" onClick={handleReset}>
            <LuRotateCcw className="h-4 w-4" />
            Reset Filters
        </Button>
    );
}
